<script setup lang="ts">
import { twMerge } from 'tailwind-merge'
</script>

<template>
  <div
    :class="
      twMerge(
        'group flex min-h-0 cursor-pointer flex-col items-stretch gap-0 rounded-corner-10 shadow-lg outline outline-1 outline-border-subtle',
        $slots.header ? 'bg-surface-tertiary' : 'bg-surface-popover',
        String($attrs.class || ''),
      )
    "
  >
    <div
      v-if="$slots.header"
      data-test="list-menu-header"
      class="flex items-center text-sm-12px-default text-text-subtlest"
    >
      <slot name="header" />
    </div>
    <div
      class="h-full rounded-corner-10 bg-surface-popover"
      :class="{ contents: !$slots.header }"
    >
      <slot />
    </div>
  </div>
</template>
